import type { SVGProps } from 'react'

const ClubRankIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="123"
    height="116"
    viewBox="0 0 123 116"
    fill="none"
    style={{ transform: 'translate(-20px, -10px)' }}
    {...props}
  >
    <g clipPath="url(#clip0_6488_24076)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.5156 30.9228L41.784 42.6406C37.8899 43.6841 34.7429 44.5273 32.2589 45.4112C29.6959 46.3263 27.5173 47.3923 25.6774 49.0325C22.7535 51.6411 20.7334 55.0949 19.9068 58.8986C19.3877 61.2916 19.5466 63.6856 20.024 66.3293C20.4871 68.9006 21.3244 72.0062 22.3561 75.8567L28.0212 96.9989C29.0529 100.849 29.8854 103.956 30.7652 106.416C31.6737 108.944 32.7331 111.097 34.379 112.91C36.9964 115.793 40.4733 117.775 44.3109 118.573C46.7244 119.074 49.1428 118.903 51.82 118.414C54.4132 117.938 57.5601 117.094 61.4543 116.051L105.186 104.333C109.08 103.29 112.222 102.448 114.711 101.563C117.269 100.649 119.448 99.5827 121.288 97.9425C124.214 95.3343 126.235 91.88 127.063 88.0751C127.582 85.6822 127.423 83.2882 126.946 80.6445C126.478 78.0744 125.645 74.9675 124.614 71.117L118.949 49.9748C117.917 46.1243 117.084 43.0174 116.205 40.5577C115.296 38.0295 114.232 35.8781 112.586 34.0653C109.97 31.1828 106.495 29.1997 102.659 28.4003C100.241 27.9011 97.8223 28.0719 95.1499 28.5596C92.5519 29.0374 89.4097 29.8794 85.5156 30.9228ZM61.3022 66.0709C60.8123 64.2428 62.5256 62.5705 64.3683 63.0869L83.8317 68.552C84.2399 68.6669 84.6105 68.8846 84.9075 69.1839C85.2046 69.4833 85.4179 69.8541 85.5267 70.2603C85.6355 70.6665 85.6362 71.0943 85.5287 71.502C85.4211 71.9098 85.209 72.2836 84.9129 72.5872L70.7897 87.0518C70.486 87.3633 70.1047 87.5897 69.6848 87.7081C69.2649 87.8265 68.8214 87.8325 68.3997 87.7256C67.9779 87.6187 67.593 87.4027 67.2842 87.0997C66.9755 86.7966 66.754 86.4174 66.6423 86.0007L61.3022 66.0709Z"
        fill="#414151"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_24076">
        <rect
          width="120"
          height="120"
          fill="white"
          transform="translate(0 31.0586) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
)

export { ClubRankIcon }
